var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("PRODUCTIE INFO")
      ]),
      _vm._v(" "),
      !_vm.barcode && !_vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode om productie informatie weer te geven.\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(
                " Ophalen informatie " + _vm._s(_vm.barcode) + "...\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && _vm.item && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  _c("th", [_vm._v("Status")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getProductionStatusBadge(_vm.item))
                    }
                  })
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Productiebon")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.productionReceipt
                          ? _vm.getPrintStatusBadge(
                              _vm.item.productionReceipt.printStatus
                            )
                          : ""
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Pakbon")]),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.item.packingSlip
                          ? _vm.getPrintStatusBadge(
                              _vm.item.packingSlip.printStatus
                            )
                          : ""
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Barcode")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.barcode))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Product")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.product.productName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Variant")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.variation.variationName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Productie datum")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.productionDate))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Aflever datum")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.item.deliveryDate))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Opties")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.item.logo
                      ? _c("span", [_vm._v("+ Logo"), _c("br")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.attachments.length > 0
                      ? _c("span", [_vm._v("+ Brief"), _c("br")])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.item && _vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td"), _vm._v(" "), _c("td")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4596736a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4596736a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductionItemInfo.vue
// module id = u65/
// module chunks = 1